import { defineMessages } from '@approvalmax/utils';

export const messages = defineMessages('pages.RequestList.ContactInfo', {
    accountNumber: 'Account number: {accountNumber}',
    taxNumber: 'Tax ID: {taxNumber}',
});
